"use client";

import { FC, MouseEventHandler } from "react";

export type SliderArrowProps = {
  onClick?: MouseEventHandler<HTMLSpanElement>;
};

export const PrevArrow: FC<SliderArrowProps> = ({ onClick }) => (
  <span className="slick-prev" onClick={onClick}>
    <i className="isax isax-arrow-left" />
  </span>
);

export const NextArrow: FC<SliderArrowProps> = ({ onClick }) => (
  <span className="slick-next" onClick={onClick}>
    <i className="isax isax-arrow-right-1" />
  </span>
);
